/* Stock vs. ETF — Ch. 8.
   Random-walk simulation of one stock vs. an S&P-style index over 20 years. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function rnd(mean, sd) {
    var u = 1 - Math.random(), v = Math.random();
    return mean + sd * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
  }
  var SECTORS = {
    tech:       { mean: 0.10, sd: 0.30, label: 'Technology' },
    consumer:   { mean: 0.08, sd: 0.20, label: 'Consumer' },
    energy:     { mean: 0.06, sd: 0.35, label: 'Energy' },
    healthcare: { mean: 0.09, sd: 0.22, label: 'Healthcare' },
    retail:     { mean: 0.07, sd: 0.28, label: 'Retail' }
  };

  class StockVsEtf {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.state = { sector: u.sector || 'tech' };
      this.principal = 1000; this.years = 20;
      this.render(); this.attach(); this.runOnce();
    }
    render() {
      this.el.innerHTML = `
        <div class="sim-layout">
          <div class="sim-controls">
            <div class="sim-field">
              <label class="sim-field__label" for="sector">Stock sector</label>
              <select id="sector" data-state="sector">
                ${Object.keys(SECTORS).map(k => `<option value="${k}" ${this.state.sector === k ? 'selected' : ''}>${SECTORS[k].label}</option>`).join('')}
              </select>
            </div>
            <p class="sim-result__sub">Investing <strong>$1,000</strong> for <strong>20 years</strong>.<br>Index = S&amp;P 500 (8% mean, 15% σ).</p>
            <button class="btn btn--outline btn--sm" data-act="run">Run 1 simulation</button>
            <button class="btn btn--primary btn--sm" data-act="run100">Run 100 simulations</button>
          </div>
          <div class="sim-results">
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:16px;">
              <div class="sim-result"><div class="sim-result-label" style="color:var(--yellow-hover);">Stock final</div><div class="sim-result-primary" data-out="stock">$0</div></div>
              <div class="sim-result"><div class="sim-result-label" style="color:var(--yellow);">ETF final</div><div class="sim-result-primary" data-out="etf">$0</div></div>
            </div>
            <div class="sim-chart-wrap"><canvas id="sve-chart"></canvas></div>
            <div class="sim-insight" data-out="insight"></div>
          </div>
        </div>`;
    }
    attach() {
      var sel = this.el.querySelector('#sector');
      sel.addEventListener('change', () => { this.state.sector = sel.value; this.runOnce(); IT.url.write({ sector: this.state.sector }); });
      this.el.querySelector('[data-act="run"]').addEventListener('click', () => this.runOnce());
      this.el.querySelector('[data-act="run100"]').addEventListener('click', () => this.run100());
    }
    walk(mean, sd) {
      var v = this.principal, path = [v];
      for (var y = 0; y < this.years; y++) {
        v *= (1 + rnd(mean, sd));
        if (v < 0) v = 0;
        path.push(v);
      }
      return path;
    }
    runOnce() {
      var sec = SECTORS[this.state.sector];
      var stock = this.walk(sec.mean, sec.sd);
      var etf   = this.walk(0.08, 0.15);
      this.draw(stock, etf, null);
      this.el.querySelector('[data-out="stock"]').textContent = fmt(stock[stock.length - 1]);
      this.el.querySelector('[data-out="etf"]').textContent   = fmt(etf[etf.length - 1]);
      this.el.querySelector('[data-out="insight"]').innerHTML =
        'The S&amp;P 500 has had no losing 20-year period in its history. Stock-picking can win — but only sometimes.';
    }
    run100() {
      var sec = SECTORS[this.state.sector];
      var outcomes = [], etfFinal = 0;
      for (var i = 0; i < 100; i++) {
        outcomes.push(this.walk(sec.mean, sec.sd).slice(-1)[0]);
        if (i === 0) etfFinal = this.walk(0.08, 0.15).slice(-1)[0];
      }
      var sorted = outcomes.slice().sort((a, b) => a - b);
      var med = sorted[50], worst = sorted[0];
      var beat = outcomes.filter(o => o > etfFinal).length;
      this.draw(null, null, { outcomes, etfFinal });
      this.el.querySelector('[data-out="stock"]').textContent = fmt(med) + ' (median)';
      this.el.querySelector('[data-out="etf"]').textContent   = fmt(etfFinal);
      this.el.querySelector('[data-out="insight"]').innerHTML =
        `In <strong>${100 - beat}</strong> of 100 simulations the index fund beat the stock. Median stock: <strong>${fmt(med)}</strong>. Worst: <strong>${fmt(worst)}</strong>.`;
    }
    draw(stockPath, etfPath, hist) {
      if (!window.Chart) { setTimeout(() => this.draw(stockPath, etfPath, hist), 200); return; }
      var ctx = this.el.querySelector('#sve-chart');
      if (this._chart) this._chart.destroy();
      var T = window.IT_TOKENS;
      if (hist) {
        var bins = new Array(20).fill(0);
        var max = Math.max.apply(null, hist.outcomes);
        var step = max / 20;
        hist.outcomes.forEach(v => { bins[Math.min(19, Math.floor(v / step))]++; });
        this._chart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: bins.map((_, i) => '$' + Math.round(i * step / 1000) + 'k'),
            datasets: [{ label: '100 stock outcomes', data: bins, backgroundColor: T.red }]
          },
          options: {
            responsive: true, maintainAspectRatio: false,
            scales: { x: { grid: { display: false } }, y: {} }
          }
        });
      } else {
        this._chart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: stockPath.map((_, i) => i),
            datasets: [
              { label: 'Single stock', data: stockPath, borderColor: T.red,    borderWidth: 2, pointRadius: 0, tension: 0.2 },
              { label: 'S&P 500 ETF', data: etfPath,   borderColor: T.yellow, borderWidth: 2, pointRadius: 0, tension: 0.2 }
            ]
          },
          options: {
            responsive: true, maintainAspectRatio: false,
            scales: {
              x: { title: { display: true, text: 'Year' } },
              y: { ticks: { callback: v => '$' + (v >= 1000 ? (v/1000).toFixed(0) + 'k' : v) } }
            }
          }
        });
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => new StockVsEtf('simulator-container'));
})();
